export default __webpack_public_path__ + "static/ashley bandy-03376fa63b47a763ee7db1b8914fb0d8.png";